import { useEffect, useState, forwardRef, useRef, useImperativeHandle } from "react";
import "./style.css";

export const DragDropFile = forwardRef((props, ref) => {
    const { onFileChange, id, multiple } = props;
    const [dragActive, setDragActive] = useState(false);
    const inputRef = useRef(null);

    useImperativeHandle(ref, () => ({
        uploadFile() {
            inputRef.current.click();
        },

        clearFile() {
            inputRef.current.value = "";
        },
    }));

    const handleDrag = function (event) {
        if (event.type === "dragenter" || event.type === "dragover") {
            setDragActive(true);
        } else if (event.type === "dragleave") {
            setDragActive(false);
            event.preventDefault();
            event.stopPropagation();
        }
    };

    const handleDrop = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            // at least one file has been dropped so do something
            onFileChange(e.dataTransfer.files);
        }
    };

    const handleChange = function (e) {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            // at least one file has been selected so do something
            // handleFiles(e.target.files);
            onFileChange(e.target.files);
        }
    };

    const handleLabelClick = () => {
        inputRef.current.click();
    };

    return (
        <div id={"form-file-upload-" + id} className="form-file-upload" onDragEnter={handleDrag}>
            <input
                ref={inputRef}
                type="file"
                id={"input-file-upload-" + id}
                className="input-file-upload"
                multiple={multiple}
                onChange={handleChange}
            />
            <label
                id={"label-file-upload-" + id}
                htmlFor={"input-file-upload-" + id}
                className={dragActive ? "label-file-upload drag-active" : "label-file-upload"}>
                <div>
                    <p>Click to select a file or drag and drop your file here</p>
                </div>
            </label>
            {dragActive && (
                <div
                    id={"drag-file-element-" + id}
                    className="drag-file-element"
                    onDragEnter={handleDrag}
                    onDragLeave={handleDrag}
                    onDragOver={handleDrag}
                    onDrop={handleDrop}></div>
            )}
        </div>
    );
});
